<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="490" :persistent="loading">
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on" class="import-button">Импорт</div>
      </template>
      <div v-if="!loading" @click="close" class="close">
        <Icon name="close" />
      </div>

      <v-card class="wrapper">
        <div class="modal_title">Импорт скриптов</div>

        <div v-if="loading" class="import-loader">
          <v-progress-circular
            indeterminate
            color="#4B5EFF"
            :size="52"
            :width="5"
          />

          <div class="loader-title">Импортируем скрипты</div>

          <div class="loader-description">
            Загружено {{ completed }} из {{ total }}
          </div>
        </div>

        <div
          v-else
          class="upload-area"
          :class="{ 'upload-area--dragover': isDragover }"
          @click="$refs.fileInput.click()"
          @dragover.prevent="isDragover = true"
          @dragleave.prevent="isDragover = false"
          @drop.prevent="dropFiles"
        >
          <input
            ref="fileInput"
            class="file-input"
            type="file"
            accept=".json,application/json"
            multiple
            @change="importFiles"
          />

          <Icon name="upload" />

          <div class="upload-title">Выберите или перетащите файлы</div>

          <div class="upload-description">
            Можно загрузить сразу несколько JSON-файлов
          </div>
        </div>

        <div v-if="!loading" class="cancel_modal" @click="close">Отменить</div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Icon from '../../SetIcon.vue';

export default {
  components: {
    Icon,
  },

  props: ['callback_refresh'],

  data() {
    return {
      dialog: false,
      isDragover: false,
      loading: false,
      completed: 0,
      total: 0,
      loadingStartedAt: 0,
    };
  },

  methods: {
    close() {
      if (this.loading) return;

      this.dialog = false;
    },

    importFiles(event) {
      const files = Array.from(event.target.files || []);

      event.target.value = '';

      this.processFiles(files);
    },

    dropFiles(event) {
      this.isDragover = false;

      const files = Array.from(event.dataTransfer.files || []);

      this.processFiles(files);
    },

    processFiles(files) {
      const jsonFiles = files.filter((file) =>
        file.name.toLowerCase().endsWith('.json'),
      );

      if (!jsonFiles.length) {
        alert('Выберите JSON-файлы');
        return;
      }

      if (jsonFiles.length > 10) {
        alert('За один раз можно импортировать не более 10 скриптов');
        return;
      }

      this.loading = true;
      this.completed = 0;
      this.total = jsonFiles.length;
      this.loadingStartedAt = Date.now();

      jsonFiles.forEach((file) => {
        const reader = new FileReader();

        reader.onload = (loadEvent) => {
          try {
            const fileContent = String(loadEvent.target.result);
            const parsed = JSON.parse(fileContent);
            // старый экспорт из редактора сохранял сценарий строкой внутри JSON
            const scenarioData =
              typeof parsed === 'string' ? parsed : fileContent;
            const fileName = file.name.replace(/\.json$/i, '');

            this.$http.post(
              '/script/import',
              {
                data: {
                  name: fileName,
                  created_at: Math.round(Date.now() / 1000),
                  data: scenarioData,
                },
              },
              () => {
                this.completed++;

                if (this.completed === this.total) {
                  this.finishImport();
                }
              },
            );
          } catch (error) {
            this.completed++;

            console.error('Неверный JSON:', file.name, error);

            if (this.completed === this.total) {
              this.finishImport();
            }
          }
        };

        reader.onerror = () => {
          this.completed++;

          console.error('Не удалось прочитать файл:', file.name);

          if (this.completed === this.total) {
            this.finishImport();
          }
        };

        reader.readAsText(file);
      });
    },
    finishImport() {
      const passed = Date.now() - this.loadingStartedAt;
      const remaining = Math.max(5000 - passed, 0);

      setTimeout(() => {
        this.loading = false;
        this.callback_refresh();
        this.close();
      }, remaining);
    },
  },
};
</script>

<style scoped>
.import-button {
  box-sizing: border-box;
  padding: 11px 20px;
  background: #ffffff;
  color: #2b2d33;
  border: 1px solid #4b5eff;
  border-radius: 8px;
  font-weight: 600;
  font-size: 15px;
  line-height: 18px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.import-button:hover {
  background: #f4f6ff;
}

.wrapper {
  padding: 32px;
  border-radius: 8px;
}

.modal_title {
  padding: 0;
  margin-bottom: 24px;
  color: #2b2d33;
  font-weight: 800;
  font-size: 24px;
  line-height: 130%;
  text-align: center;
}

.upload-area {
  min-height: 150px;
  padding: 24px;
  border: 2px dashed #aaabad;
  border-radius: 12px;
  background: #ffffff;
  cursor: pointer;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  transition: border-color 0.2s, background-color 0.2s, box-shadow 0.2s,
    transform 0.2s;
}

.upload-area:hover {
  border-color: #4b5eff;
  background: #f4f6ff;
}

.file-input {
  display: none;
}

.upload-area .icon {
  margin-bottom: 12px;
}

.upload-title {
  color: #4b5eff;
  font-weight: 600;
  font-size: 15px;
  line-height: 120%;
}

.upload-description {
  margin-top: 8px;
  color: #aaabad;
  font-weight: 500;
  font-size: 13px;
  line-height: 130%;
  text-align: center;
}

.cancel_modal {
  margin-top: 20px;
  color: #4b5eff;
  font-weight: 500;
  font-size: 15px;
  line-height: 120%;
  text-align: center;
  cursor: pointer;
}
.upload-area--dragover {
  border-color: #4b5eff;
  background: #f4f6ff;
}
.import-loader {
  min-height: 200px;
  padding: 24px;
  background: #f7f8ff;
  border: 1px solid #e1e4ff;
  border-radius: 12px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.loader-title {
  margin-top: 20px;
  color: #2b2d33;
  font-weight: 700;
  font-size: 17px;
  line-height: 120%;
  text-align: center;
}

.loader-description {
  margin-top: 8px;
  padding: 6px 12px;
  color: #4b5eff;
  background: #ffffff;
  border-radius: 20px;
  font-weight: 600;
  font-size: 13px;
  line-height: 130%;
  text-align: center;
}
.upload-area--dragover {
  border-color: #4b5eff;
  background: #f4f6ff;
  box-shadow: 0 4px 16px rgba(75, 94, 255, 0.12);
  transform: translateY(-2px);
}
</style>
